import "./App.scss";
import "./misc/main.scss";
import "./misc/pb-tailwind.scss";

import NavBar from "./component/NavBar";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import EventDetailPage from "./pages/EventDetailPage";
import ResultPage from "./pages/ResultPage";
import DonationPage from "./pages/DonationPage";
import DonationResultPage from "./pages/DonationResultPage";
import ConfirmationPage from "./pages/ConfirmationPage";
import QRCodePage from "./pages/QRCodePage";
import MemberPage from "./pages/MemberPage";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { createTheme, ThemeProvider } from "@mui/material";
import Payment from "./pages/Payment";
import Test from "./pages/Test";

// sandbox;
const clientId =
  "Aab7poM4gyLGF61NpH44mTuURQg9wtXPNq5GyiiEwg4N5Enl2tEJoiXOiNVYMUHbzyOuoErrUsSiHb0Q";

// live MGP
// const clientId =
//   "AUz6dE-xKIEx6wNVgOmgtetnO7fogmEHjJIInPzPNSKgGNm7BzxHgY1aGlzuW44n93ZDs56P13RlcZQG";

const theme = createTheme({
  palette: {
    primary: {
      light: "#fcca72",
      main: "#f9ba4c",
      dark: "#fa8123",
      contrastText: "#fff",
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <PayPalScriptProvider
          options={{
            "client-id": clientId,
            currency: "HKD", // Set your preferred currency here
            locale: "en_HK",
          }}
        >
          <div className="App">
            <NavBar />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<EventDetailPage />}>
                  <Route path=":id" element={<EventDetailPage />} />
                </Route>
                <Route path="/donation" element={<DonationPage />} />
                <Route path="/donation/:id" element={<DonationResultPage />} />
                {/* <Route path="/test" element={<Test />} /> */}

                <Route
                  path="/confirmation/:type"
                  element={<ConfirmationPage />}
                />

                {/* <Route path="/payment/:type" element={<QRCodePage />} /> */}
                <Route path="/payment/:type" element={<Payment />} />

                {/* <Route path="/payment/test" element={<Payment />} /> */}

                <Route path="/result/:id" element={<ResultPage />} />
                <Route path="/member/:id" element={<MemberPage />} />
              </Routes>
            </BrowserRouter>
          </div>
        </PayPalScriptProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
